import React, { useState } from "react";
import s from "./style.module.scss";
import GoBack from "shared/ui/GoBack";
import RegistrationForm from "features/Auth/RegistrationForm";
import ConfirmCodeForm from "features/Auth/ConfirmCodeForm";
import LoginForm from "features/Auth/LoginForm";
import { useNavigate } from "react-router-dom";

const RegistrationContent: React.FC = () => {
  const navigate = useNavigate();

  const [phone, setPhone] = useState("+7(");
  const [codeSent, setCodeSent] = useState(false);
  const [haveCode, setHaveCode] = useState(false);

  const handleGoBack = () => {
    if (codeSent) {
      setCodeSent(false);
      return;
    }

    if (haveCode) {
      setHaveCode(false);
      return;
    }

    navigate(-1);
  };

  return (
    <section className={s.registration}>
      <GoBack callback={handleGoBack} black />

      <h1>{haveCode ? "Вход" : "Регистрация"}</h1>

      {!haveCode ? (
        <>
          {codeSent ? (
            <ConfirmCodeForm phone={phone} />
          ) : (
            <RegistrationForm
              phone={phone}
              setCodeSent={setCodeSent}
              setPhone={setPhone}
              setHaveCode={setHaveCode}
            />
          )}
        </>
      ) : (
        <LoginForm phone={phone} />
      )}
    </section>
  );
};

export default RegistrationContent;
